<mat-toolbar class="main-header">
  <button (click)="toggleSidenav.emit()" mat-icon-button #tooltip="matTooltip" matTooltip="Toggle navigation"
    matTooltipPosition="after" matTooltipShowDelay="300">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="branding">
    <a href="/#">
      <img src="assets/images/vias_logo_en.png" height="40" alt="viaShipyard" />
    </a>
  </div>
  <div class="search-bar" fxFlex>
    <!-- genisletmek icin -->
  </div>
  <span>{{ 'welcome' | translate }} {{userName}}</span>
  <button [matMenuTriggerFor]="user" mat-icon-button class="ml-xs" #tooltip="matTooltip" matTooltip="User links"
    matTooltipPosition="before" matTooltipShowDelay="300" class="ml-xs header-avatar">
    <img src="assets/images/vias76x76.png" alt="" class="toolbar-avatar radius-circle">
  </button>
</mat-toolbar>

<!--Apps Menu-->
<mat-menu #apps="matMenu" x-position="before">
  <div fxLayout="row" class="pa-xs">
    <div fxFlex="33.3333" class="text-xs-center pa-1">
      <a [routerLink]="['/messages']" class="block">
        <span class="block">
          <mat-icon class="h1 mat-text-default">email</mat-icon>
        </span>
        <small class="text-muted">Emails</small>
      </a>
      <a [routerLink]="['/calendar']" class="mt-2 block">
        <span class="block">
          <mat-icon class="h1 mat-text-muted">date_range</mat-icon>
        </span>
        <small class="text-muted">Calendar</small>
      </a>
    </div>
    <div fxFlex="33.3333" class="text-xs-center pa-1">
      <a [routerLink]="['/social']" class="block">
        <span class="block">
          <mat-icon class="h1 mat-text-warn">person</mat-icon>
        </span>
        <small class="text-muted">Social</small>
      </a>
      <a [routerLink]="['/maps/google']" class="mt-2 block">
        <span class="block">
          <mat-icon class="h1 mat-text-default">place</mat-icon>
        </span>
        <small class="text-muted">Map</small>
      </a>
    </div>
    <div fxFlex="33.3333" class="text-xs-center pa-1">
      <a [routerLink]="['/messsages']" class="block">
        <span class="block">
          <mat-icon class="h1 mat-text-accent">ondemand_video</mat-icon>
        </span>
        <small class="text-muted">Media</small>
      </a>
      <a [routerLink]="['/taskboard']" class="mt-2 block">
        <span class="block">
          <mat-icon class="h1 mat-text-primary">view_column</mat-icon>
        </span>
        <small class="text-muted">Tasks</small>
      </a>
    </div>
  </div>
</mat-menu>

<!--User Menu-->
<mat-menu #user="matMenu" x-position="before">

  <button mat-menu-item [matMenuTriggerFor]="apps">
    <mat-icon>apps</mat-icon>
    Apps
  </button>
  <button mat-menu-item [matMenuTriggerFor]="notifications">
    <mat-icon>notifications</mat-icon>
    Notification
  </button>
  <button mat-menu-item>
    <mat-icon>settings</mat-icon>
    Settings
  </button>
  <button mat-menu-item [routerLink]="['/social']">
    <mat-icon>account_box</mat-icon>
    Profile
  </button>
  <button mat-menu-item>
    <mat-icon>notifications_off</mat-icon>
    Disable notifications
  </button>
  <button mat-menu-item [routerLink]="['/account/logout']">
    <mat-icon>exit_to_app</mat-icon>
    {{'logout'|translate}}
  </button>
</mat-menu>

<!--Notification Menu-->
<mat-menu #notifications="matMenu" x-position="before" class="notifications">
  <mat-toolbar>
    <span class="mr-1 ml-1">Notifications</span>
  </mat-toolbar>
  <div [perfectScrollbar]="config" class="notifications-inner">
    <mat-nav-list>
      <mat-list-item *ngFor="let notice of notificationService.getAll()">
        <mat-icon mat-list-avatar class="mat-text-{{ notice?.color }} mat-icon mat-list-avatar material-icons">{{
          notice.icon }}</mat-icon>
        <h4 matLine>{{ notice.text }}</h4>
        <p matLine *ngIf="notice.subtext">{{ notice.subtext }}</p>
        <span class="text-md mat-text-muted" matLine *ngIf="notice.date">{{ notice.date | date: 'fullDate' }}</span>
      </mat-list-item>
    </mat-nav-list>
  </div>
</mat-menu>
